import { hot } from "react-hot-loader";

import React from "react";
import { bool, func } from "prop-types";

import * as S from "./styled";

const ZoomControls = ({ disableZoomIn, disableZoomOut, zoomIn, zoomOut }) => (
  <S.ZoomStyleDiv>
    <S.TopButtonStyle
      aria-label="Zoom In"
      disabled={disableZoomIn}
      onClick={zoomIn}
    >
      <i aria-hidden="true" className="fa fa-plus" />
    </S.TopButtonStyle>
    <S.BottomButtonStyle
      aria-label="Zoom Out"
      disabled={disableZoomOut}
      onClick={zoomOut}
    >
      <i aria-hidden="true" className="fa fa-minus" />
    </S.BottomButtonStyle>
  </S.ZoomStyleDiv>
);

ZoomControls.propTypes = {
  disableZoomIn: bool,
  disableZoomOut: bool,
  zoomIn: func.isRequired,
  zoomOut: func.isRequired
};

ZoomControls.defaultProps = {
  disableZoomIn: false,
  disableZoomOut: false
};

export default hot(module)(ZoomControls);
